import { useEffect } from "react"
import { useTranslation } from "react-i18next"

import { SiteFooter } from "./components/SiteFooter"
import { SiteHeader } from "./components/SiteHeader"
import { ContactSection } from "./sections/ContactSection"
import { FaqSection } from "./sections/FaqSection"
import { HeroSection } from "./sections/HeroSection"
import { ModelSection } from "./sections/ModelSection"
// 支付与结算区块暂时下线，恢复时与下方 <PaymentSection /> 一起打开
// import { PaymentSection } from "./sections/PaymentSection"
import { RefundSection } from "./sections/RefundSection"
import { TermsSection } from "./sections/TermsSection"

/**
 * henghengmall 官网首页（桌面优先 + 移动端自适应）
 *
 * 内容取自早期单页官网版本，文案走官网私有 i18n（中 / 英 / 柬），
 * 待填写的资质与联系信息集中在 site-config.ts。
 */
export default function OfficialPage() {
  const { t } = useTranslation()

  // 锚点导航平滑滚动（只作用于官网，不影响其他落地页）
  useEffect(() => {
    const previous = document.documentElement.style.scrollBehavior
    document.documentElement.style.scrollBehavior = "smooth"
    return () => {
      document.documentElement.style.scrollBehavior = previous
    }
  }, [])

  return (
    <div className="min-h-screen bg-white text-ink">
      <a
        href="#main"
        className="absolute left-[-9999px] top-0 z-[100] bg-ink px-4 py-2.5 text-white focus:left-3 focus:top-3"
      >
        {t("official_skip_content")}
      </a>

      <SiteHeader />

      <main id="main">
        <HeroSection />
        <ModelSection />
        {/* <PaymentSection /> */}
        <RefundSection />
        <TermsSection />
        <FaqSection />
        <ContactSection />
      </main>

      <SiteFooter />
    </div>
  )
}
